import { render, staticRenderFns } from "./informationSource.vue?vue&type=template&id=10992b75"
import script from "./informationSource.vue?vue&type=script&lang=js"
export * from "./informationSource.vue?vue&type=script&lang=js"
import style0 from "./informationSource.vue?vue&type=style&index=0&id=10992b75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports